import { IConfiguration } from './types'

export const DEFAULT_CONFIGURATION: IConfiguration = {
  backtrace: false,
  dryRun: false,
  forceExit: false,
  failFast: false,
  format: [],
  formatOptions: {},
  plugin: [],
  pluginOptions: {},
  import: [],
  language: 'en',
  loader: [],
  name: [],
  order: 'defined',
  paths: [],
  parallel: 0,
  publish: false,
  require: [],
  requireModule: [],
  retry: 0,
  retryTagFilter: '',
  shard: '',
  strict: true,
  tags: '',
  worldParameters: {},
}
